import React, { Component, Fragment } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import "./monthly-invoice.css";
import {
  getAllEmployeeRedux,
  uploadSourcingRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
  recomputeSourcingMonthStatsRedux,
} from "../../../../actions/index";
import { sendNotifications } from "../../../../firebase/fcmRestApi";
import {
  uploadImage,
  updateImage,
  deleteImage,
} from "../../../../firebase/firebase.utils";
import firebase from "firebase/app";
import { connect } from "react-redux";
import man from "../../plus image.jpeg";

const emptyProductRow = () => ({
  id: `${Date.now()}${Math.floor(Math.random() * 1000)}`,
  imageUrl: "",
  productName: "",
  priceRmb: "",
  quantity: "",
});

export class SoldMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      productDetails: "",
      productName: "",
      productsArray: [],
      totalPaid: 0,
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      country: "",
      agentPaid: 0,
      initialProfit: 0,
      algProfit: 0,
      recalculating: false,
    };
  }

  handleRecalculateStats = async () => {
    this.setState({ recalculating: true });
    await this.props.recomputeSourcingMonthStatsRedux();
    this.setState({ recalculating: false });
  };

  addProductRow = () => {
    this.setState({
      productsArray: [...this.state.productsArray, emptyProductRow()],
    });
  };

  updateProductRow = (id, field, value) => {
    this.setState({
      productsArray: this.state.productsArray.map((product) =>
        product.id === id ? { ...product, [field]: value } : product,
      ),
    });
  };

  removeProductRow = (id) => {
    const removed = this.state.productsArray.find(
      (product) => product.id === id,
    );
    if (removed && removed.imageUrl) {
      deleteImage(removed.imageUrl);
    }
    this.setState({
      productsArray: this.state.productsArray.filter(
        (product) => product.id !== id,
      ),
    });
  };

  handleProductImageChange = async (id, file) => {
    if (!file) return;
    const existing = this.state.productsArray.find(
      (product) => product.id === id,
    );
    const imgUrl = existing && existing.imageUrl
      ? await updateImage(file, existing.imageUrl, "zapaiProducts")
      : await uploadImage(file, "zapaiProducts");
    if (imgUrl) {
      this.updateProductRow(id, "imageUrl", imgUrl);
    }
  };

  getProductsGrandTotal = () =>
    this.state.productsArray.reduce(
      (sum, product) =>
        sum +
        (parseFloat(product.priceRmb) || 0) *
          (parseFloat(product.quantity) || 0),
      0,
    );

  componentDidMount = async () => {
    this.props.getAllEmployeeRedux();
    await this.props.ensureCurrentMonthStatsRedux();
    this.props.getAllSourcingMonthStatsRedux();
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    const date = new Date();
    if (this.state.customer === "") {
      alert("Please enter a customer name first");
      return;
    }
    const productsArray = this.state.productsArray.map((product) => ({
      ...product,
      totalRmb: (
        (parseFloat(product.priceRmb) || 0) *
        (parseFloat(product.quantity) || 0)
      ).toFixed(2),
    }));
    await this.props.uploadSourcingRedux({
      ...this.state,
      id: date.getTime().toString(),
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      localWarehouseDateTimeStamp: firebase.firestore.Timestamp.now(),
      status: "pending",
      totalBill:
        parseInt(
          parseFloat(this.state.sellRate) * parseFloat(this.state.totalRmb),
        ) + parseInt(this.state.shipping || 0),
      category: "sourcing",
      invoiceStatus: "Not Paid",
      sourcingStatus: "Pending",
      productsArray,
      productName: productsArray.length > 0 ? productsArray[0].productName : "",
    });
    this.props.getAllSourcingMonthStatsRedux();

    const message = {
      title: `Order Invoice`,
      body: `A new Order invoice has been added to your account.Please check the information.`,
    };
    const userObj = this.props.allUsers.find(
      (user) => user.uid == this.state.customerUid,
    );
    if (userObj && userObj.deviceToken && userObj.deviceToken.length > 0) {
      userObj.deviceToken.map((token) => {
        sendNotifications(token, message);
      });
    }
    this.setState({
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      productDetails: "",
      productName: "",
      productsArray: [],
      totalPaid: 0,
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      country: "",
      agentPaid: 0,
      initialProfit: 0,
      algProfit: 0,
    });
  };

  render() {
    const { monthStats, allEmployees } = this.props;

    return (
      <Fragment>
        <Breadcrumb title="Monthly" parent="Wholesale Management/Order" />
        <div className="container-fluid">
          <div className="col-sm-12">
            <div className="card">
              <div
                className="card-header"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h5>
                  <i
                    className="icofont-list"
                    style={{
                      fontSize: "130%",
                      marginRight: "5px",
                      color: "darkblue",
                    }}
                  ></i>
                  Order Invoice
                </h5>
                <div style={{ display: "flex", gap: 10 }}>
                  <button
                    className="btn btn-outline-secondary"
                    disabled={this.state.recalculating}
                    onClick={this.handleRecalculateStats}
                    title="Recompute every month's stats from scratch by re-scanning all invoices. Use this if the numbers on this page look out of sync."
                  >
                    {this.state.recalculating
                      ? "Recalculating..."
                      : "Recalculate stats"}
                  </button>
                  <button
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#personalInfoModal"
                    onClick={() => {
                      this.setState({
                        agent: "",
                        totalRmb: "",
                        sellRate: "",
                        buyRate: "",
                        productLink: "",
                        productDetails: "",
                        productName: "",
                        productsArray: [],
                        totalPaid: 0,
                        buyingCost: 0,
                        finalProfit: 0,
                        cursor: -1,
                        customer: "",
                        customerUid: "",
                      });
                    }}
                  >
                    New Invoice
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="clearfix"></div>
                <div id="basicScenario" className="product-physical">
                  <Datatable history={this.props.history} myData={monthStats} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "95%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(0, 37, 76)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Create Order Invoice
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>

              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      ORDER AGENT
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="agent"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.agent}
                    >
                      <option value="">SELECT EMPLOYEE</option>
                      {allEmployees.map((employee) => (
                        <option value={`${employee.name}`}>
                          {employee.name}-{employee.designation}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      CUSTOMER NAME
                    </label>
                    <input
                      style={{ padding: 18 }}
                      type="text"
                      name="customer"
                      className="form-control"
                      placeholder="Enter customer name"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.customer}
                      required
                      autoComplete="off"
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      SELECT COUNTRY
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="country"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={this.handleChange}
                      value={this.state.country}
                    >
                      <option value="">SELECT COUNTRY</option>
                      <option value="INDIA">INDIA</option>
                      <option value="CHINA">CHINA</option>
                    </select>
                  </div>
                  {this.state.country && (
                    <>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          Products
                        </label>
                        {this.state.productsArray.length > 0 ? (
                          <div
                            className="consultancy-packing-summary"
                            data-toggle="modal"
                            data-target="#packingListModal"
                          >
                            <img
                              className="consultancy-packing-thumb"
                              src={
                                this.state.productsArray[0].imageUrl || man
                              }
                              alt=""
                            />
                            <span className="consultancy-packing-name">
                              {this.state.productsArray[0].productName ||
                                "Unnamed product"}
                            </span>
                            {this.state.productsArray.length > 1 && (
                              <span className="consultancy-packing-more">
                                +{this.state.productsArray.length - 1} more
                                product
                                {this.state.productsArray.length - 1 === 1
                                  ? ""
                                  : "s"}
                              </span>
                            )}
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="consultancy-packing-add-btn"
                            data-toggle="modal"
                            data-target="#packingListModal"
                          >
                            + Add products
                          </button>
                        )}
                      </div>

                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          TOTAL{" "}
                          {this.state.country == "INDIA" ? "RUPEES" : "RMB"}
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="totalRmb"
                          value={this.state.totalRmb}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="Total"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          {this.state.country == "INDIA" ? "RUPEES" : "RMB"}{" "}
                          SELL RATE
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="sellRate"
                          value={this.state.sellRate}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="sell rate"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label
                          style={{
                            fontWeight: "bold",
                            color: "#505050",
                            marginBottom: 5,
                          }}
                        >
                          {this.state.country == "INDIA" ? "RUPEES" : "RMB"} BUY
                          RATE
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="buyRate"
                          value={this.state.buyRate}
                          onChange={this.handleChange}
                          id="exampleFormControlInput1"
                          placeholder="buy rate"
                          style={{
                            borderColor: "gainsboro",
                            borderRadius: 5,
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Create Invoice
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="packingListModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="packingListModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content consultancy-modal"
              style={{ margin: "auto" }}
            >
              <div className="modal-header">
                <div
                  className="modal-title"
                  id="packingListModalLabel"
                >
                  Products
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.productsArray.length === 0 && (
                  <div className="consultancy-packing-empty">
                    No products added yet.
                  </div>
                )}
                {this.state.productsArray.map((product, index) => (
                  <div className="consultancy-packing-row" key={product.id}>
                    <div className="consultancy-packing-row-image">
                      <img
                        src={product.imageUrl || man}
                        alt=""
                        onClick={() => {
                          document
                            .getElementById(`packing-image-input-${index}`)
                            .click();
                        }}
                      />
                      <input
                        id={`packing-image-input-${index}`}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          this.handleProductImageChange(
                            product.id,
                            e.target.files[0],
                          );
                        }}
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control consultancy-packing-input"
                      placeholder="Product name"
                      value={product.productName}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "productName",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Price (Rmb)"
                      value={product.priceRmb}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "priceRmb",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Qty"
                      value={product.quantity}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "quantity",
                          e.target.value,
                        )
                      }
                    />
                    <div className="consultancy-packing-row-total">
                      {(
                        (parseFloat(product.priceRmb) || 0) *
                        (parseFloat(product.quantity) || 0)
                      ).toFixed(2)}{" "}
                      Rmb
                    </div>
                    <i
                      className="icofont-trash consultancy-packing-row-remove"
                      onClick={() => this.removeProductRow(product.id)}
                    />
                  </div>
                ))}
                <button
                  type="button"
                  className="consultancy-packing-add-row-btn"
                  onClick={this.addProductRow}
                >
                  + Add product
                </button>

                <hr className="consultancy-modal-divider" />

                <div className="consultancy-packing-footer">
                  <div className="form-group consultancy-packing-shipping">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Shipping charge (all products)
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="shipping"
                      placeholder="Enter shipping charge"
                      value={this.state.shipping}
                      onChange={this.handleChange}
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="consultancy-packing-grand-total">
                    <span className="consultancy-packing-grand-total-label">
                      Products total
                    </span>
                    <span className="consultancy-packing-grand-total-value">
                      {this.getProductsGrandTotal().toFixed(2)} Rmb
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active",
    ),
    monthStats: state.sourcings.monthStats,
    allUsers: state.users.users,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
  uploadSourcingRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
  recomputeSourcingMonthStatsRedux,
})(SoldMonth);
